import { CallState as CallStatus } from "@azure/communication-calling";
import { DeviceManagerState } from "@azure/communication-react";

type ParticipantConnectionState =
    | 'Idle'
    | 'Connecting'
    | 'Ringing'
    | 'Connected'
    | 'Hold'
    | 'InLobby'
    | 'EarlyMedia'
    | 'Disconnected';

/**
 * Check if the call state represents being in the call
 */
export const isInCall = (callStatus?: CallStatus): boolean =>
    !!callStatus &&
    !['None', 'Disconnected', 'Connecting', 'Ringing', 'EarlyMedia', 'Disconnecting'].includes(callStatus);

/**
 * Check if the call state represents being in the lobby or waiting to be admitted.
 */
export const isInLobbyOrConnecting = (callStatus: CallStatus | undefined): boolean =>
    !!callStatus && ['Connecting', 'Ringing', 'InLobby', 'EarlyMedia'].includes(callStatus);

/**
 * Check if the device manager local video is on when not part of a call
 * i.e. do unparented views exist.
 */
export const isPreviewOn = (deviceManager: DeviceManagerState): boolean =>
    // TODO: we should take in a LocalVideoStream that developer wants to use as their 'Preview' view. We should also
    // handle cases where 'Preview' view is in progress and not necessary completed.
     deviceManager.unparentedViews.length > 0 && deviceManager.unparentedViews[0].view !== undefined
;

